class upsellProduct extends HTMLElement {
    constructor() {
      super();
      this.bindEvents();

    }
    bindEvents() {
        this.querySelectorAll('upsell-product .price_box_img').forEach((item) =>{
            item.addEventListener('click', this.onSummaryClick.bind(this))
        });
        this.querySelectorAll('input[name=quantity]').forEach((item) =>{
            item.addEventListener('change', this.onQtyChange.bind(this))
        });
    }
    onQtyChange() {
        if (this.classList.contains('active')) {
            return;
        }

        this.querySelector('.price_box_img').click();

    }
    onSummaryClick(event,selectItemPrice) {
        const element = event.currentTarget;
        var element_price =  parseInt(element.getAttribute("upsell-product-price"));
        var element_upsell_var_id =  element.getAttribute("upsell-var-id");

        var element_upsell_item_qty =   parseInt(element.parentNode.querySelector('.quantity__input').value);
        var totalt_product_and_upsell_product_price = parseInt(document.querySelector("#button_total_price").innerHTML);
        var Bundle_ID = document.querySelector('#bundle_properties_wrap').getAttribute('now');

        if(this.classList.contains('active')){
            var selectItemPrice =  parseInt(document.querySelector("input#temp_price").value);
            this.classList.remove('active')
            selectItemPrice = selectItemPrice - element_price;
            document.querySelector('#main_product_bundle_id').setAttribute('disabled','disabled');
            document.querySelector("input#temp_price").value = selectItemPrice;
            var final_product_upsell_price =  Shopify.formatMoney(totalt_product_and_upsell_product_price + selectItemPrice, Shopify.money_format);
            document.querySelector('.button-total-price').innerHTML = final_product_upsell_price;
            document.querySelector('.button-total-price').setAttribute('product-price',final_product_upsell_price);
            document.querySelector(`#upsell_var_ids [value="${element_upsell_var_id}"]`).remove();
            document.querySelector(`#upsell_var_ids .qty_${element_upsell_var_id}`).remove();
            document.querySelector(`#upsell_var_ids .properties_${element_upsell_var_id}`).remove();
        }else{
            var selectItemPrice =  parseInt(document.querySelector("input#temp_price").value);
            this.classList.add('active')
            selectItemPrice = selectItemPrice + element_price;
            document.querySelector("input#temp_price").value = selectItemPrice ;
            document.querySelector('#main_product_bundle_id').removeAttribute('disabled');
            var final_product_upsell_price = Shopify.formatMoney(totalt_product_and_upsell_product_price + selectItemPrice, Shopify.money_format);
            document.querySelector('.button-total-price').innerHTML = final_product_upsell_price;
            document.querySelector('.button-total-price').setAttribute('product-price',final_product_upsell_price);
            document.querySelector('#upsell_var_ids').innerHTML += `<input type="hidden" name="items[][id]" value="${element_upsell_var_id}" class="product-upsell-id">`;
            document.querySelector('#upsell_var_ids').innerHTML += `<input type="hidden" name="items[][quantity]" value="${element_upsell_item_qty}" class="product-upsell-id qty_${element_upsell_var_id}">`;
            document.querySelector('#upsell_var_ids').innerHTML += `<input type="hidden" name="items[][properties][_Bundle_ID]" value="${Bundle_ID}" class="product-upsell-id properties_${element_upsell_var_id}">`;
        }
    }
}

customElements.define('upsell-product', upsellProduct);



class upsellQtyInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');
      this.changeEvent = new Event('change', { bubbles: true });
      this.input.addEventListener('change', this.onInputChange.bind(this));
      this.querySelectorAll('button').forEach((button) =>
        button.addEventListener('click', this.onButtonClick.bind(this))
      );
    }
    onInputChange(event) {
        this.validateQtyRules();
    }
    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;
        event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }
    validateQtyRules() {
        const value = parseInt(this.input.value);
        var variant_id = this.getAttribute('data-variantid')
        document.querySelectorAll(`.qty_${variant_id}`).forEach(el => {
            el.value = value;
        });
        if (this.input.min) {
            const min = parseInt(this.input.min);
            const buttonMinus = this.querySelector(".quantity__button[name='minus']");
            buttonMinus.classList.toggle('disabled', value <= min);
        }
        if (this.input.max) {
            const max = parseInt(this.input.max);
            const buttonPlus = this.querySelector(".quantity__button[name='plus']");
            buttonPlus.classList.toggle('disabled', value >= max);
        }
    }
}
customElements.define('upsell-qty-input', upsellQtyInput);